<div class="modal">
  <div class="modal-overlay" (click)="cancel($event)"></div>

  <div class="modal-dialog w-100" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between">
        <h4 class="modal-title">{{ modalTitle }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel($event)"></button>
      </div>

      <div class="modal-body">
        <form id="addressAddDialog">
          <div class="row">
            <div class="form-floating mt-2 col-12">
              <input
                class="form-control"
                type="text"
                name="dialogAddressAddName1Input"
                id="dialogAddressAddName1InputField"
                [(ngModel)]="address.name1"
                #dialogAddressAddName1Input="ngModel"
                required
                placeholder=" "
                maxlength="40"
                (change)="address.name1 = address.name1?.trim()"
              />
              <label class="form-label" i18n="@@DialogAddressAddName1Label">Name 1</label>
            </div>
          </div>

          <div class="row">
            <div class="form-floating mt-2 col-12">
              <input
                class="form-control"
                type="text"
                name="dialogAddressAddName2Input"
                id="dialogAddressAddName2InputField"
                [(ngModel)]="address.name2"
                #dialogAddressAddName2Input="ngModel"
                placeholder=" "
                maxlength="40"
                (change)="address.name2 = address.name2?.trim()"
              />
              <label class="form-label" i18n="@@DialogAddressAddName2Label">Name 2</label>
            </div>
          </div>

          <div class="row">
            <div class="form-floating mt-2 col-12">
              <input
                class="form-control"
                type="text"
                name="dialogAddressAddName3Input"
                id="dialogAddressAddName3InputField"
                [(ngModel)]="address.name3"
                #dialogAddressAddName3Input="ngModel"
                placeholder=" "
                maxlength="40"
                (change)="address.name3 = address.name3?.trim()"
              />
              <label class="form-label" i18n="@@DialogAddressAddName3Label">Name 3</label>
            </div>
          </div>

          <div class="row">
            <div class="form-floating mt-2 col-4">
              <input
                class="form-control"
                type="text"
                name="dialogAddressAddZipCodeInput"
                id="dialogAddressAddZipCodeInputField"
                [(ngModel)]="address.zipCode"
                #dialogAddressAddZipCodeInput="ngModel"
                required
                placeholder=" "
                maxlength="10"
                (change)="address.zipCode = address.zipCode?.trim()"
              />
              <label class="form-label" i18n="@@DialogAddressAddZipCodeLabel">Postal Code</label>
            </div>

            <div class="form-floating mt-2 col-8">
              <input
                class="form-control"
                type="text"
                name="dialogAddressAddCityInput"
                id="dialogAddressAddCityInputField"
                [(ngModel)]="address.city"
                #dialogAddressAddCityInput="ngModel"
                required
                placeholder=" "
                maxlength="40"
                (change)="address.city = address.city?.trim()"
              />
              <label class="form-label" i18n="@@DialogAddressAddCityLabel">City</label>
            </div>
          </div>

          <div class="row">
            <div class="form-floating mt-2 col-12">
              <input
                class="form-control"
                type="text"
                name="dialogAddressAddStreetInput"
                id="dialogAddressAddStreetInputField"
                [(ngModel)]="address.street"
                #dialogAddressAddStreetInput="ngModel"
                required
                placeholder=" "
                maxlength="40"
                (change)="address.street = address.street?.trim()"
              />
              <label class="form-label" i18n="@@DialogAddressAddStreetLabel">Street</label>
            </div>
          </div>

          <div class="row">
            <div class="form-floating mt-2 col-12">
              <div class="form-floating">
                <app-country-combo-box
                  name="dialogAddressAddCountryCodeInput"
                  class="form-control px-0 py-0"
                  [countryList]="countryList"
                  [selectedCountry]="selectedCountry"
                  (valueChanged)="onCountryCodeChange($event)"
                  required
                ></app-country-combo-box>
                <label class="countryComboboxLabel" for="dialogAddressAddCountryCodeInput" i18n="@@DialogAddressAddCountryCodeLabel">Country</label>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="submit()">{{ submitButtonLabel }}</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel($event)">{{ cancelButtonLabel }}</button>
      </div>
    </div>
  </div>
</div>
